<template>
  <div id="zarob-si-mesacne" class="sc-money">
    <div class="container">
      <div class="row -align-center">
        <div class="column -md5">
          <div class="sc-money-content">
            <h2 class="sc-title -margin-bottom">Zaraď vyššiu rýchlosť</h2>
            <p>
              Pozri si, koľko s nami môžeš za mesiac zarobiť sprostredkovaním finančných služieb v regiónoch.
            </p>
            <p>
              Všetko závisí len od tvojej šikovnosti. Do kalkulačky zadaj, na koľko si trúfaš a my ti povieme odhadovaný zárobok.
            </p>
          </div>
        </div>
        <div class="column -md7 sc-money-calculator">
          <SCCalulator/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SCCalulator from '@/components/SCCalculator.vue';

export default {
  components: {
    SCCalulator,
  },
};
</script>

<style lang="scss" scoped>
.sc-money {
  padding: 50px 0;
  @media screen and (min-width: $screen-md) {
    padding: 120px 0 200px;
    background-image: url('../assets/sc/pattern-money.svg');
    background-position: left bottom;
    background-repeat: no-repeat;
    .sc-money-content {
      max-width: 370px;
    }
  }
}
</style>
